import React, { useRef } from 'react';
import { FileUp, Loader2, X } from 'lucide-react';
import { xhrUpload } from '../../../lib/upload';
import { LABEL } from './quoteOptions';

const MAX_FILES = 5;
const ACCEPT = '.png,.jpg,.jpeg,.webp,.gif,.svg,.pdf,.ai,.eps,.psd,.tif,.tiff,.zip';
let seq = 0;

export default function ArtworkField({ files, setFiles, error }) {
  const inputRef = useRef(null);
  const patch = (key, p) => setFiles((list) => list.map((f) => (f.key === key ? { ...f, ...p } : f)));

  const onPick = (e) => {
    const picked = [...(e.target.files || [])].slice(0, MAX_FILES - files.length);
    e.target.value = '';
    picked.forEach((file) => {
      const key = `a${(seq += 1)}`;
      setFiles((list) => [...list, { key, name: file.name, status: 'uploading', progress: 0 }]);
      xhrUpload('/api/quotes/artwork', file, (p) => patch(key, { progress: p }))
        .then((res) => patch(key, { status: 'done', id: res.id }))
        .catch((err) => patch(key, { status: 'error', error: err.message }));
    });
  };

  return (
    <div data-testid="quote-artwork">
      <p className={LABEL}>Artwork <span className="normal-case tracking-normal text-[#7a7a7a] font-normal">(optional · up to 5 files, 25 MB each)</span></p>
      <ul className="flex flex-col gap-2 mb-3">
        {files.map((f) => (
          <li key={f.key} className="flex items-center gap-3 rounded-lg border border-white/10 bg-[#0f0f0f] px-4 py-2.5 text-sm" data-testid="quote-artwork-item" data-status={f.status}>
            {f.status === 'uploading' ? <Loader2 className="w-4 h-4 text-[#00b8ff] animate-spin" /> : <FileUp className="w-4 h-4 text-[#00b8ff]" />}
            <span className="text-[#f4efe6] truncate flex-1">{f.name}</span>
            <span className={`text-xs ${f.status === 'error' ? 'text-red-400' : 'text-[#7a7a7a]'}`}>
              {f.status === 'uploading' ? `${f.progress}%` : f.status === 'error' ? f.error : 'Uploaded'}
            </span>
            <button type="button" onClick={() => setFiles((l) => l.filter((x) => x.key !== f.key))} aria-label={`Remove ${f.name}`} className="text-[#7a7a7a] hover:text-red-400" data-testid="quote-artwork-remove">
              <X className="w-4 h-4" />
            </button>
          </li>
        ))}
      </ul>
      {files.length < MAX_FILES && (
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          className="w-full rounded-lg border border-dashed border-white/15 px-4 py-4 text-sm text-[#cfc8bb] hover:border-[#00b8ff] hover:text-[#00b8ff] transition-colors duration-200"
          data-testid="quote-artwork-btn"
        >
          Upload logos or designs — PNG, JPG, SVG, PDF, AI, EPS, PSD, TIFF or ZIP
        </button>
      )}
      <input ref={inputRef} type="file" multiple accept={ACCEPT} className="hidden" onChange={onPick} data-testid="quote-artwork-input" />
      {error && <p className="text-xs text-red-400 mt-2">{error}</p>}
    </div>
  );
}
